const INSTANT_CLASS = 'announcement-slider__track--instant';

class AnnouncementSlider extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.announcement-slider__track');
    this.total = this.querySelectorAll('.announcement-slider__slide').length;

    if (!this.track || this.total < 2) return;

    this.current = Number(this.track.dataset.index) || 0;
    this.autoplayMs = (Number(this.dataset.autoplaySpeed) || 5) * 1000;

    this.handleTransitionEnd = this.handleTransitionEnd.bind(this);
    this.startAutoplay = this.startAutoplay.bind(this);
    this.stopAutoplay = this.stopAutoplay.bind(this);

    this.track.addEventListener('transitionend', this.handleTransitionEnd);
    this.addEventListener('mouseenter', this.stopAutoplay);
    this.addEventListener('mouseleave', this.startAutoplay);
    this.addEventListener('focusin', this.stopAutoplay);
    this.addEventListener('focusout', this.startAutoplay);

    this.startAutoplay();
  }

  disconnectedCallback() {
    this.stopAutoplay();
    this.track?.removeEventListener('transitionend', this.handleTransitionEnd);
    this.removeEventListener('mouseenter', this.stopAutoplay);
    this.removeEventListener('mouseleave', this.startAutoplay);
    this.removeEventListener('focusin', this.stopAutoplay);
    this.removeEventListener('focusout', this.startAutoplay);
  }

  advance() {
    // Slides are stacked in reverse order, so counting the index *down*
    // shifts the track downward — each message enters from the top.
    this.current -= 1;
    this.track.dataset.index = String(this.current);
  }

  handleTransitionEnd(event) {
    if (event.target !== this.track || event.propertyName !== 'transform') return;
    if (this.current > 0) return;

    // Index 0 is a duplicate of the first message. Once it has animated in,
    // snap back to the real one with no transition so the loop is seamless.
    this.current = this.total - 1;
    this.track.classList.add(INSTANT_CLASS);
    this.track.dataset.index = String(this.current);
    void this.track.offsetHeight;
    this.track.classList.remove(INSTANT_CLASS);
  }

  startAutoplay() {
    this.stopAutoplay();
    this.timer = setInterval(() => this.advance(), this.autoplayMs);
  }

  stopAutoplay() {
    if (!this.timer) return;
    clearInterval(this.timer);
    this.timer = null;
  }
}

if (!customElements.get('announcement-slider')) {
  customElements.define('announcement-slider', AnnouncementSlider);
}
